<i18n lang='yml' src='./i18n/MoreLess.yml'></i18n>

<template>
  <div class="logbook-description" aria-hidden="true">
    <div>
      <div v-html="truncate && descriptionText.length > maxDisplay ? descriptionText.substring(0, maxDisplay) + '...' : descriptionText"/>
      <button class="btn btn-link" @click="truncateText" v-if="descriptionText.length > maxDisplay">{{ truncate ? $t('view_more') : $t('view_less') }}</button>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      descriptionText: {type: String},
    },
    data() {
      return {
        truncate: true,
        maxDisplay: {type: Number, default: 400},
      }
    },
    mounted() {
      this.windowResize()
    },
    created() {
      window.addEventListener("resize", this.windowResize);
    },
    methods: {
      truncateText() {
        this.truncate = !this.truncate 
      },
      windowResize(e) {
        var w = window.innerWidth;
        if (w <= 550) {
          this.maxDisplay = 220;
        } else if (w >= 551 && w <= 768){
          this.maxDisplay = 280;
        } else if (w >= 769 && w <= 990){
          this.maxDisplay = 380;
        } else if (w >= 991 && w <= 1200){
          this.maxDisplay = 320;
        } else if (w >= 1201 && w <= 1400){
          this.maxDisplay = 400;
        } else if (w >= 1401) { 
          this.maxDisplay = 515;
        }
      }
    }
  };
</script>
